import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Video } from '../../_model/video/video';
import { environment } from '../../../environments/environment';
import { Subscription, Unsubscribable } from 'rxjs';
import { ApiUrlHelper } from 'app/_service/api-url-helper';
import { HttpClientHelper } from 'app/_service/http-helper';
import { map } from 'rxjs/operators';
import { ScreenSize, WindowService } from 'app/_service/screen-size.service';

export enum VideoDisplay {
  Full,
  Teaser,
  SmallTeaser,
  Compact,
  Detail,
  SearchList,
  News,
  NewsBlock,
  ChannelBlock
}

@Component({
  selector: 'div.video-item',
  templateUrl: './video-teaser.component.html',
  styleUrls: ['./video-teaser-share.scss','./video-teaser.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class VideoTeaserComponent implements OnInit, OnChanges, OnDestroy {
  isAdult = environment.cinema === 2;
  @Input()
  video: Video;

  @Input()
  display = VideoDisplay.Teaser;

  @Input() ngClass = {};

  videoDisplay = VideoDisplay;


  @Input()
  listStyle = false;

  @Input()
  fromList = false;

  @Input()
  hasWatched = false;

  private subscription: Array<Unsubscribable> = [];
  playList;
  screenType = ScreenSize;
  screenSize: ScreenSize = ScreenSize.Large;
  episodeBlocks = 7;
  episodeSegment = 3;
  sportsBlocks = 3;
  sportsSegement = 1;
  subscriptions: Subscription[] = [];
  // @Input()
  // imgWidth;
  // @Input()
  // imgHeight;
  constructor(
    // private _windowService: WindowService,
    private _apiUrlHelper: ApiUrlHelper,
    private _httpClientHelper: HttpClientHelper,
    public _windowService: WindowService,
  ) {

    // this.subscription.push( this._windowService.size$.subscribe((value: any) => {
    //   this.screenSize = value;
    // }));
  }
  niceTag ='';
  ngOnChanges(changes: SimpleChanges): void {
    if(!!changes['video'] && !!changes['video'].currentValue)
    {
      let video = changes['video'].currentValue;
      if(!!video.cidMapper)
      {
        this.niceTag = this.replaceComma(video.cidMapper);
      }
      else
      {
        if(!video.tags)
        {
          this.niceTag = video.cid;
        }
        else if(video.tags.length>0)
        {
          this.niceTag = video.tags.join('　');
        }
      }
      // if(!video.tags)
      // {

      // }
      // else{

      // }
    }
  }
  // mouseEvent() {
  //   this.mouseHoverd.emit();
  // }

  ngOnDestroy(): void {
    //console.log("destoryed")
    this.subscription.forEach(p => p.unsubscribe());
    this.subscriptions.forEach(s => s.unsubscribe());
  }
 
  ngOnInit() {
    // this.route.queryParams.subscribe(params => {
    //  // console.log(this.route.snapshot)
    //   const keyword = params['keyword'] || Utility.GetSearchKey();
    //   if (keyword) {
    //     this.video.title = this.video.title.replace(keyword, '<span class="text-red">' + keyword + '</span>');
    //     this.video.actors = this.video.actors.map(actor => {
    //       if (actor === keyword) {
    //         return '<span class="text-red">' + keyword + '</span>';
    //       } else {
    //         return actor;
    //       }
    //     });

    //   }
    // });
    //console.log(this.video)

  }

  // refactorLastUpdate() {
  //   const value = this.video.lastUpdate;
  //   if (value) {
  //     if (value.includes('更新到')) {
  //       return '<span class="mr-1">更新</span>' + '<span class="text-red"><b>' + this.video.lastUpdate.replace('更新到', '') + '</b></span>';
  //     }
  //     return '<span>' + this.video.lastUpdate + '</span>';
  //   }
  //   return "";
  // }

  getEpisode() {
    const apiURL = this._apiUrlHelper.urlBuilder('languagesplaylist', {
      vid: this.video.key,
      taxis: 1,
    });
    return this._httpClientHelper.get(apiURL)
      .pipe(map((res) => {
        return res;
      }));
  }

  replaceComma(r) {
    if (r !== null && r !== undefined) {
      return r.replace(/,/g, ' ');
    }
  }

}
